export type LeaveGuard = () => boolean | Promise<boolean>;

const leaveGuards = new Set<LeaveGuard>();

export function registerLeaveGuard(guard: LeaveGuard) {
  leaveGuards.add(guard);
}

export function unregisterLeaveGuard(guard: LeaveGuard) {
  leaveGuards.delete(guard);
}

export async function confirmRegisteredLeaveGuards(): Promise<boolean> {
  for (const guard of Array.from(leaveGuards)) {
    const canLeave = await guard();

    if (!canLeave) {
      return false;
    }
  }

  return true;
}
